import { OrganizationType } from '@front-app/services/OrganizationsApi/OrganizationModel';

// The fucking API returns an English string. Why.
const FROM_ENGLISH: Record<string, OrganizationType> = {
	'Allied Health': OrganizationType.ALLIED_HEALTH,
	Biotechnology: OrganizationType.BIOTECHNOLOGY,
	Dental: OrganizationType.DENTAL,
	'Diagnostic Service Provider': OrganizationType.DIAGNOSTIC_SERVICE_PROVIDER,
	'Educational Institute': OrganizationType.EDUCATIONAL_INSTITUTE,
	'Family Medicine': OrganizationType.FAMILY_MEDICINE,
	Government: OrganizationType.GOVERNMENT,
	'Health Sciences': OrganizationType.HEALTH_SCIENCES,
	'Home Health Care': OrganizationType.HOME_HEALTH_CARE,
	Hospital: OrganizationType.HOSPITAL,
	Insurance: OrganizationType.INSURANCE,
	'Long Term Care': OrganizationType.LONG_TERM_CARE,
	'Medical Equipment': OrganizationType.MEDICAL_EQUIPMENT,
	'Medical Laboratory': OrganizationType.MEDICAL_LABORATORY,
	'Medical Legal Claim': OrganizationType.MEDICAL_LEGAL_CLAIM,
	'Medical Publishers': OrganizationType.MEDICAL_PUBLISHERS,
	'Mental Healthcare': OrganizationType.MENTAL_HEALTHCARE,
	'Not-for-profit Foundations & Associations': OrganizationType.NOT_FOR_PROFIT_FOUNDATIONS_AND_ASSOCIATIONS,
	Pharmaceutical: OrganizationType.PHARMACEUTICAL,
	Pharmacy: OrganizationType.PHARMACY,
	Rehabilitation: OrganizationType.REHABILITATION,
	'Self Employment': OrganizationType.SELF_EMPLOYMENT,
	'Specialty Medicine': OrganizationType.SPECIALTY_MEDICINE,
	'Therapy / Wellness Clinic': OrganizationType.THERAPY_WELLNESS_CLINIC,
	'Walk-in Care': OrganizationType.WALK_IN_CARE,
	Other: OrganizationType.OTHER,
};

const TO_ENGLISH: Record<OrganizationType, string> = {
	[OrganizationType.ALLIED_HEALTH]: 'Allied Health',
	[OrganizationType.BIOTECHNOLOGY]: 'Biotechnology',
	[OrganizationType.DENTAL]: 'Dental',
	[OrganizationType.DIAGNOSTIC_SERVICE_PROVIDER]: 'Diagnostic Service Provider',
	[OrganizationType.EDUCATIONAL_INSTITUTE]: 'Educational Institute',
	[OrganizationType.FAMILY_MEDICINE]: 'Family Medicine',
	[OrganizationType.GOVERNMENT]: 'Government',
	[OrganizationType.HEALTH_SCIENCES]: 'Health Sciences',
	[OrganizationType.HOME_HEALTH_CARE]: 'Home Health Care',
	[OrganizationType.HOSPITAL]: 'Hospital',
	[OrganizationType.INSURANCE]: 'Insurance',
	[OrganizationType.LONG_TERM_CARE]: 'Long Term Care',
	[OrganizationType.MEDICAL_EQUIPMENT]: 'Medical Equipment',
	[OrganizationType.MEDICAL_LABORATORY]: 'Medical Laboratory',
	[OrganizationType.MEDICAL_LEGAL_CLAIM]: 'Medical Legal Claim',
	[OrganizationType.MEDICAL_PUBLISHERS]: 'Medical Publishers',
	[OrganizationType.MENTAL_HEALTHCARE]: 'Mental Healthcare',
	[OrganizationType.NOT_FOR_PROFIT_FOUNDATIONS_AND_ASSOCIATIONS]: 'Not-for-profit Foundations & Associations',
	[OrganizationType.PHARMACEUTICAL]: 'Pharmaceutical',
	[OrganizationType.PHARMACY]: 'Pharmacy',
	[OrganizationType.REHABILITATION]: 'Rehabilitation',
	[OrganizationType.SELF_EMPLOYMENT]: 'Self Employment',
	[OrganizationType.SPECIALTY_MEDICINE]: 'Specialty Medicine',
	[OrganizationType.THERAPY_WELLNESS_CLINIC]: 'Therapy / Wellness Clinic',
	[OrganizationType.WALK_IN_CARE]: 'Walk-in Care',
	[OrganizationType.OTHER]: 'Other',
};

export const fromEnglishString = (str: string): OrganizationType | undefined => FROM_ENGLISH[str];

export const toEnglishString = (type: OrganizationType): string => TO_ENGLISH[type];
